import { TrackedWalletTableBoughtCell } from '../ui/tracked-wallet-table-bought-cell'
import { TrackedWalletTableLastActiveCell } from '../ui/tracked-wallet-table-last-active-cell'
import { TrackedWalletTableMakerCell } from '../ui/tracked-wallet-table-maker-cell'
import { TrackedWalletTableRemainingCell } from '../ui/tracked-wallet-table-remaining-cell'
import { TrackedWalletTableSoldCell } from '../ui/tracked-wallet-table-sell-cell'

import type {
  TrackedWalletTableColumnId,
  TrackedWalletTableContext,
} from './reatom-tracked-wallet-column-id'
import type { Maker } from '@root/entities/trade'
import type { Column } from '@root/shared/ui-kit'

export const createTrackedWalletTableColumns = () => {
  const columns: Array<
    Column<Maker.Maker, TrackedWalletTableColumnId, TrackedWalletTableContext>
  > = [
    {
      id: 'maker',
      render: ({ value }) => (
        <TrackedWalletTableMakerCell makerAddress={value.address} />
      ),
      header: ({ t }) => t('table.maker'),
      getValue: (x) => x.address,
      minWidth: 80,
    },
    {
      id: 'bought',
      render: ({ value }) => (
        <TrackedWalletTableBoughtCell
          buys={value.buys}
          buyVolumeInUsd={value.buyVolumeInUsd}
          buyVolumeCurrency={value.buyVolumeCurrency}
        />
      ),
      header: ({ t }) => t('table.bought'),
      minWidth: 80,
    },
    {
      id: 'sold',
      render: ({ value }) => (
        <TrackedWalletTableSoldCell
          sells={value.sells}
          sellVolumeCurrency={value.sellVolumeCurrency}
          sellVolumeInUsd={value.sellVolumeInUsd}
        />
      ),
      header: ({ t }) => t('table.sold'),
      minWidth: 80,
    },
    {
      id: 'remaining',
      render: ({ value }) => (
        <TrackedWalletTableRemainingCell
          balanceInUsd={value.balanceInUsd}
          balanceInUsdPercentage={value.balanceInUsdPercentage}
        />
      ),
      header: ({ t }) => t('table.remaining'),
      getValue: (x) => x.address,
      minWidth: 60,
      justify: 'stretch',
    },
    {
      id: 'active',
      render: ({ value }) => (
        <TrackedWalletTableLastActiveCell lastTradeAt={value.lastTradeAt} />
      ),
      header: ({ t }) => t('table.active'),
      getValue: (x) => x.lastTradeAt,
      width: 140,
      justify: 'end',
    },
  ]

  return columns
}
